/*
  UIComponents
  Main UI module that manages the availability of all UI-related components
*/

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { MaskitoDirective } from '@maskito/angular';
import { NgModule } from '@angular/core';

import { EntityCardModule } from '@component/entity-card';
import { FlowMaterialModule } from '@app/flow-material.module';
import { FroalaModule } from '@component/froala-editor';
import { FunctionPipeModule } from '@pipe/function';
import { MessageBoxModule } from '@component/message-box';
import { PipesModule } from '@app/shared/pipes/pipes.modules';
import { ServiceProviderRequestModule } from '@component/service-provider-request';

import { StepperModule } from '../stepper/stepper.module';
import { UIComponentsModule } from '../ui-components.module';

import { EntitySelectorComponent } from './investment-profile-selector/entity-selector';
import { FormSingleComponent } from './form-single/form-single.component';
import { FormWizardComponent } from './form-wizard/form-wizard.component';
import { InvestmentProfileSelectorComponent } from './investment-profile-selector';
import { InvestmentProfileSummaryComponent } from './investment-profile-summary';
import { ProviderAccessRequestComponent } from './provider-access-request/provider-access-request.component';
import { RenderedFormComponent } from './rendered-form.component';
import { SectionComponent } from './section/section.component';

@NgModule({
  declarations: [
    EntitySelectorComponent,
    FormSingleComponent,
    FormWizardComponent,
    InvestmentProfileSelectorComponent,
    InvestmentProfileSummaryComponent,
    ProviderAccessRequestComponent,
    RenderedFormComponent,
    SectionComponent
  ],
  exports: [
    FormSingleComponent,
    FormWizardComponent,
    EntitySelectorComponent,
    InvestmentProfileSelectorComponent,
    InvestmentProfileSummaryComponent,
    ProviderAccessRequestComponent,
    RenderedFormComponent,
    SectionComponent
  ],
  imports: [
    CommonModule,
    EntityCardModule,
    FlowMaterialModule,
    FormsModule,
    FroalaModule,
    FunctionPipeModule,
    InlineSVGModule,
    MaskitoDirective,
    MessageBoxModule,
    PipesModule,
    ReactiveFormsModule,
    ServiceProviderRequestModule,
    StepperModule,
    UIComponentsModule
  ],
  providers: []
})
export class RenderedFormModule {}
